import React, { useCallback, useContext, useEffect, useState } from 'react';
import SocketContext from "../../providers/Socket";
import Notifications from "./Notifications";
import useSearch from "../../hooks/use-search";
import { STATUS_CLICKED, STATUS_OPENED, STATUS_SEEN } from "../../constants/status";
import { getDataFromStorage } from "../../libs/auth.helper";
import MainContainer from "../MainContainer";
export var EnumNotificationStatus;
(function (EnumNotificationStatus) {
    EnumNotificationStatus[EnumNotificationStatus["CLICKED"] = 80] = "CLICKED";
    EnumNotificationStatus[EnumNotificationStatus["SEEN"] = 70] = "SEEN";
})(EnumNotificationStatus || (EnumNotificationStatus = {}));
const LIMIT_HISTORY = 100;
const HeaderComponent = ({ config, header: Header }) => {
    if (!Header)
        return React.createElement(React.Fragment, null);
    return React.createElement(Header, { states: config.states, actions: config.actions });
};
const DEFAULT_DELTA_DETAILS = {
    lower_id: -1,
    time: 0,
    upper_id: -1
};
const ReadStatus = [
    STATUS_SEEN, STATUS_OPENED, STATUS_CLICKED
];
var FilterReadEnum;
(function (FilterReadEnum) {
    FilterReadEnum[FilterReadEnum["All"] = -1] = "All";
    FilterReadEnum[FilterReadEnum["Read"] = 1] = "Read";
    FilterReadEnum[FilterReadEnum["UNREAD"] = 2] = "UNREAD";
})(FilterReadEnum || (FilterReadEnum = {}));
var FilterTapEnum;
(function (FilterTapEnum) {
    FilterTapEnum[FilterTapEnum["All"] = -1] = "All";
    FilterTapEnum[FilterTapEnum["MyAds"] = 1] = "MyAds";
    FilterTapEnum[FilterTapEnum["OtherAds"] = 2] = "OtherAds";
})(FilterTapEnum || (FilterTapEnum = {}));
const DEFAULT_FILTER = {
    read: FilterReadEnum.All,
    tap: FilterTapEnum.All
};
const NotificationsPage = (props) => {
    var _a;
    const { socket, initialNotification } = useContext(SocketContext);
    const [hasMore, setHasMore] = useState(true);
    const [tap, setTap] = useState(1);
    const [readableFilter, setReadableFilter] = useState('all');
    const [load, setIsloading] = useState(true);
    const [notifications, setNotifications] = useState([]);
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState(DEFAULT_FILTER);
    const { filteredData: filteredNotifications, searchQuery, onChangeSearchQuery } = useSearch({
        fields: [
            "text_en",
            'text_ar',
            'title_en',
            'title_ar',
        ],
        items: notifications
    });
    const memberId = (_a = getDataFromStorage().userInfo.id) !== null && _a !== void 0 ? _a : 0;
    useEffect(() => {
        if (!socket)
            return;
        socket.on('delta-end', function () {
            console.log('delta-end');
        });
        socket.on('timeline-notification', function (data) {
            setNotifications(prevNotifications => {
                return [data, ...prevNotifications];
            });
        });
        socket.on('timeline-bulk-status', function (data) {
            socket.emit('timeline-history', {
                "lower_id": -1,
                "upper_id": -1,
                "limit": LIMIT_HISTORY,
                "slice": true
            });
            socket === null || socket === void 0 ? void 0 : socket.emit('get-stats');
        });
        return () => {
            socket === null || socket === void 0 ? void 0 : socket.off('delta-updates');
            socket === null || socket === void 0 ? void 0 : socket.off('delta-end');
            socket === null || socket === void 0 ? void 0 : socket.off('timeline-notification');
            socket === null || socket === void 0 ? void 0 : socket.off('delta-inserts');
            socket === null || socket === void 0 ? void 0 : socket.off('timeline-bulk-status');
            socket === null || socket === void 0 ? void 0 : socket.off("delta-end");
            socket === null || socket === void 0 ? void 0 : socket.off('delta-inserts');
        };
    }, [socket]);
    const setSearch = (text) => {
        onChangeSearchQuery(text);
    };
    const markAllAsRead = useCallback(() => {
        var _a, _b;
        if (!socket)
            return;
        const firstNotification = (_a = notifications[0]) !== null && _a !== void 0 ? _a : 0;
        const lastNotification = (_b = notifications[notifications.length - 1]) !== null && _b !== void 0 ? _b : 0;
        socket === null || socket === void 0 ? void 0 : socket.emit('timeline-set-bulk-status', {
            lower_id: 0,
            upper_id: firstNotification.timeline_id,
            status: EnumNotificationStatus.SEEN
        });
        socket === null || socket === void 0 ? void 0 : socket.emit('get-stats');
        socket === null || socket === void 0 ? void 0 : socket.emit('timeline-history', {
            lower_id: -1,
            upper_id: lastNotification.timeline_id,
            limit: LIMIT_HISTORY,
            slice: true
        });
    }, [socket, notifications]);
    function fetchData() {
        const lastNotification = notifications[notifications.length - 1];
        if (!lastNotification)
            return;
        socket === null || socket === void 0 ? void 0 : socket.emit('timeline-history', {
            lower_id: -1,
            upper_id: lastNotification.timeline_id,
            limit: LIMIT_HISTORY,
            slice: true
        });
    }
    const filterReadHandler = useCallback((data) => {
        if (filter.read === FilterReadEnum.All) {
            return data;
        }
        return data.filter(item => {
            if (filter.read === FilterReadEnum.Read)
                return ReadStatus.includes(item.status);
            return !ReadStatus.includes(item.status);
        });
    }, [filter.read]);
    const filterTapHandler = useCallback((data) => {
        if (filter.tap === FilterTapEnum.All) {
            return data;
        }
        return data.filter(item => {
            if (filter.tap === FilterTapEnum.MyAds)
                return item.user_id === memberId;
            return item.user_id !== memberId;
        });
    }, [filter.tap]);
    const filterEventHandler = useCallback((notifications) => {
        notifications = filterTapHandler(notifications);
        notifications = filterReadHandler(notifications);
        return notifications;
    }, [filterTapHandler, filterReadHandler]);
    const onChangeReadFilter = (status) => setFilter((currentFilter) => {
        return Object.assign(Object.assign({}, currentFilter), { read: status });
    });
    const onChangeTapFilter = (status) => setFilter((currentFilter) => {
        return Object.assign(Object.assign({}, currentFilter), { tap: status });
    });
    useEffect(() => {
        if (!socket)
            return;
        setIsloading(true);
        socket.emit('timeline-history', {
            "lower_id": -1,
            "upper_id": -1,
            "limit": LIMIT_HISTORY,
            "slice": true
        });
        socket.on('delta-inserts', function (data) {
            setIsloading(false);
            setNotifications(prevNotifications => {
                return [
                    ...filterEventHandler(data.inserts)
                ];
            });
        });
        return () => {
            socket === null || socket === void 0 ? void 0 : socket.off('delta-inserts');
        };
    }, [socket, filterEventHandler]);
    const config = {
        actions: {
            filterNotification: onChangeReadFilter,
            onClickAllAdsButtonHandler: () => onChangeTapFilter(FilterTapEnum.All),
            onClickMyAdsButtonHandler: () => onChangeTapFilter(FilterTapEnum.MyAds),
            onClickOtherAdsButtonHandler: () => onChangeTapFilter(FilterTapEnum.OtherAds),
            onChangeListing: onChangeTapFilter,
            onChangeReadableFilter: onChangeReadFilter,
            onClickMarkAllButtonHandler: markAllAsRead,
            onSearchAds: (text) => setSearch(text)
        },
        states: {
            searchQuery
        }
    };
    return (React.createElement(MainContainer, null,
        React.createElement("div", { className: "card" },
            React.createElement("div", { className: "card-header ps-3 pe-3" },
                React.createElement("div", { className: 'row w-100 align-items-center justify-content-between' },
                    React.createElement(HeaderComponent, { config: config, header: props.header }))),
            React.createElement("div", { className: "card-body pt-4 px-0" },
                React.createElement("div", { className: "tab-content px-9 hover-scroll-overlay-y pe-7 me-3 mb-2" },
                    React.createElement("div", { className: "tab-pane fade show active", id: "kt_list_widget_16_tab_1", role: "tabpanel", style: {
                            height: "80vh",
                        } },
                        React.createElement(Notifications, { load: load, notifications: filteredNotifications, setNotifications: setNotifications, NotificationItem: props.NotificationItem })))))));
};
export default NotificationsPage;
